import { render, staticRenderFns } from "./ToDoCollapseList.vue?vue&type=template&id=632d9cc5&scoped=true"
import script from "./ToDoCollapseList.vue?vue&type=script&lang=js"
export * from "./ToDoCollapseList.vue?vue&type=script&lang=js"
import style0 from "./ToDoCollapseList.vue?vue&type=style&index=0&id=632d9cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d9cc5",
  null
  
)

export default component.exports